import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Switch, BrowserRouter } from 'react-router-dom';

import i18nInit from '../../config/i18n';
import App from '../../components/App';
import MainScreen from '../MainScreen';
import GlobalAdminStatsScreen from '../GlobalAdminStatsScreen';
import PrivateRoute from '../../components/common/PrivateRoute';

class Root extends React.Component {
  constructor(props) {
    super(props);
    i18nInit('en');
  }

  render() {
    const { store } = this.props;

    return (
      <Provider store={store}>
        <BrowserRouter>
          <div className="app">
            <Switch>
              <PrivateRoute exact path="/" component={MainScreen} />
              <PrivateRoute exact path='/global-admin-stats' component={GlobalAdminStatsScreen} />
            </Switch>
            <App />
          </div>
        </BrowserRouter>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
};

export default Root;
